<div class="hm-root">
  <!-- ====================== PUBLIC HERO (Homepage A) ====================== -->
  <section class="hm-hero" *ngIf="!member" aria-label="Search the market">
    <div class="hm-hero-inner">
      <p class="hm-hero-eyebrow">The UK private registration market</p>
      <h1 class="hm-hero-title">
        Every registration. One home.
      </h1>
      <p class="hm-hero-lead">
        Dealer listings across the market, tracked, valued and compared, with a
        permanent page for every registration.
      </p>
      <pla-home-search></pla-home-search>
      <div class="hm-trust" role="list">
        <div class="hm-trust-item" role="listitem" *ngFor="let s of stats">
          <span class="hm-trust-n">{{ s.value }}</span>
          <span class="hm-trust-l">{{ s.label }}</span>
        </div>
      </div>
    </div>
  </section>

  <!-- ====================== MEMBER BRIEFING (Homepage B) ======================
       My Market as a personalised LAYER within the white homepage: an
       elegant two-column editorial briefing (greeting + search on the left,
       "Since you were last here" beside a feature visual on the right), not
       a full-screen dark dashboard. Photography still punctuates the page
       via the In Focus story below. -->
  <section class="hm-briefing" *ngIf="member" aria-label="My market briefing">
    <div class="hm-briefing-inner">
      <div class="hm-brf-grid">
        <!-- Left: greeting, interests, search -->
        <div class="hm-brf-lead">
          <p class="hm-eyebrow">My market</p>
          <h1 class="hm-briefing-title">{{ greeting }}</h1>
          <p class="hm-briefing-sub">
            {{ today | date: 'EEEE d MMMM' }} · {{ updatesLine }}
          </p>
          <p class="hm-brf-interests">
            <ng-container *ngIf="interestsLoaded">
              <ng-container *ngIf="interestsSummary; else noInterests">
                Your interests: {{ interestsSummary }}&ensp;<a href="#hm-foryou"
                  >Edit</a
                >
              </ng-container>
              <ng-template #noInterests>
                No interests yet&ensp;<a href="#hm-foryou">Add one</a>
              </ng-template>
            </ng-container>
          </p>
          <pla-home-search></pla-home-search>
        </div>

        <!-- Right: feature visual + "Since you were last here" -->
        <div class="hm-brf-news">
          <a
            class="hm-brf-visual"
            routerLink="/blog"
            [style.backgroundImage]="'url(' + inFocus.imageUrl + ')'"
            [attr.aria-label]="inFocus.title"
          >
            <span>{{ inFocus.eyebrow }} · {{ inFocus.title }}</span>
          </a>

          <div class="hm-briefing-list" *ngIf="briefing as b">
            <div class="hm-briefing-head">
              <span class="hm-kicker">Since you were last here</span>
              <a class="hm-more" routerLink="/account/updates"
                >All updates <span class="arw" aria-hidden="true">→</span></a
              >
            </div>
            <ng-container *ngIf="b.items.length > 0; else quietState">
              <ng-container *ngFor="let item of b.items; let i = index">
              <a
                class="hm-briefing-item"
                [class.has-picks]="item.picks?.length"
                [routerLink]="briefingLinks[i]?.path || item.targetUrl"
                [queryParams]="briefingLinks[i]?.query"
                [attr.aria-label]="
                  (item.registration || 'Market') +
                  ' · ' +
                  item.headline +
                  ' · ' +
                  item.reason.label
                "
              >
                <pla-plate class="hm-plate-slot" *ngIf="item.registration" [rawPlate]="item.formattedRegistration || item.registration"
                  [showPrice]="false" [openModal]="false" [clickThrough]="false" [center]="false"
                  [mobileSmall]="true" [customClass]="'flat shaded'" [plateSize]="'ns-s'"></pla-plate>
                <span class="hm-bi-icon" *ngIf="!item.registration && item.type?.startsWith('auction.')" aria-hidden="true">
                  <!-- gavel: line drawing -->
                  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.6"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="m14.5 12.5-8 8a2.12 2.12 0 1 1-3-3l8-8" />
                    <path d="m16 16 6-6" />
                    <path d="m8 8 6-6" />
                    <path d="m9 7 8 8" />
                    <path d="m21 11-8-8" />
                  </svg>
                </span>
                <span class="hm-briefing-copy">
                  <span class="hm-bi-line">{{ item.headline }}</span>
                  <span class="hm-bi-detail" *ngIf="item.detail">{{ item.detail }}</span>
                  <span class="hm-bi-why" *ngIf="!item.detail"
                    >{{ item.reason.label
                    }}<ng-container *ngIf="item.detectedAt">
                      · {{ asDate(item.detectedAt) | relativeTime }}</ng-container
                    ></span
                  >
                </span>
                <span class="hm-briefing-cta">View</span>
              </a>
              <div class="hm-briefing-picks" *ngIf="item.picks?.length">
                <a class="hm-bp" *ngFor="let p of item.picks" [routerLink]="p.targetUrl">
                  <pla-plate class="hm-plate-slot" [rawPlate]="p.formattedRegistration || p.registration"
                    [showPrice]="false" [openModal]="false" [clickThrough]="false" [center]="false"
                    [mobileSmall]="true" [customClass]="'flat shaded'" [plateSize]="'ns-s'"></pla-plate>
                  <span class="hm-bp-why" [class.is-match]="p.kind === 'match'" [class.is-sold]="p.kind === 'sold'">{{ p.label }}</span>
                </a>
              </div>
              </ng-container>
            </ng-container>
            <ng-template #quietState>
              <p class="hm-briefing-quiet">
                Your plates were quiet since your last visit. The market below
                wasn't.
              </p>
            </ng-template>
          </div>
          <p class="hm-briefing-quiet" *ngIf="briefingFailed">
            Your updates are unavailable right now.
            <a routerLink="/account/updates">Open your account</a>
          </p>
        </div>
      </div>
    </div>
  </section>

  <!-- ============ MEMBER: photography, then personalised For You ============
       Tone-setting photography punctuates BEFORE the personalised content;
       For You then sits as a calm editorial module on the white homepage. -->
  <pla-home-in-focus *ngIf="member"></pla-home-in-focus>

  <section class="hm-section hm-section--paper" id="hm-foryou" *ngIf="member">
    <!-- For You (LIVE: /account/for-you, interests CRUD) -->
    <pla-home-for-you></pla-home-for-you>
  </section>

  <!-- ====================== COLLECTIONS (public only) ====================== -->
  <section class="hm-collecting" *ngIf="!member">
    <div class="hm-collecting-inner">
      <div class="hm-collect-entry">
        <p class="hm-eyebrow">The Collections</p>
        <h2 class="hm-collect-stmt">
          It began as a way to personalise a car. It became a market, and a
          culture of its own.
        </h2>
        <p class="hm-collect-sub">
          Assembled by the PlateX editorial desk. Revised weekly.
        </p>
      </div>
      <div class="hm-cotw">
        <p class="hm-eyebrow">{{ collectionOfWeek.eyebrow }}</p>
        <h3 class="hm-cotw-title">{{ collectionOfWeek.title }}</h3>
        <p class="hm-cotw-copy">{{ collectionOfWeek.copy }}</p>
        <a class="hm-more" [routerLink]="collectionOfWeek.targetUrl"
          >{{ collectionOfWeek.ctaLabel }}
          <span class="arw" aria-hidden="true">→</span></a
        >
      </div>
      <div class="hm-picks">
        <a
          class="hm-pick"
          *ngFor="let pick of curatorPicks"
          [routerLink]="pick.targetUrl"
        >
          <span class="hm-kicker">{{ pick.eyebrow }}</span>
          <pla-plate class="hm-plate-slot" [rawPlate]="pick.registration" [showPrice]="false"
            [openModal]="false" [clickThrough]="false" [center]="false" [mobileSmall]="true"
            [smallPlate]="true" [customClass]="'flat shaded'"></pla-plate>
          <span class="hm-pick-copy">{{ pick.copy }}</span>
          <span class="hm-pick-fact">{{ pick.factLine }}</span>
        </a>
      </div>
    </div>
  </section>

  <!-- ====================== MARKET (shared) ====================== -->
  <section class="hm-section hm-section--paper">
    <pla-home-market
      [member]="member"
      [followed]="followed"
      [saved]="saved"
      [recent]="recent"
    ></pla-home-market>
  </section>

  <!-- ====================== IN FOCUS (public placement) ====================== -->
  <!-- Market Guides launch feature: only while a guide's free week is open (and only where enabled) -->
  <pla-guide-feature *ngIf="!member" placement="home"></pla-guide-feature>
  <pla-home-in-focus *ngIf="!member"></pla-home-in-focus>

  <!-- ====================== REGISTRY (shared) ====================== -->
  <pla-home-registry [member]="member" [summary]="summary"></pla-home-registry>

  <!-- ====================== CLOSE (member only) ======================
       Held back for the public launch (the redundant public "In Closing"
       panel is removed so the footer follows the Registry section). Retained
       for the member homepage; shows again when My Market is reintroduced. -->
  <section class="hm-close" *ngIf="member">
    <div class="hm-close-inner">
      <p class="hm-eyebrow">In closing</p>
      <h2 class="hm-close-title">
        {{
          member
            ? 'Your market, on the record.'
            : 'Every registration is more than a number.'
        }}
      </h2>
      <p class="hm-close-sub">
        {{
          member
            ? 'Until next time.'
            : 'Where the private registration market lives.'
        }}
      </p>
    </div>
  </section>
</div>
